import { api } from "./api";

// Shared reference-data cache: company-level data (projects, crew, billing
// status, profile) is identical across routes — fetch once per TTL, dedupe
// inflight requests, and let pages render from cache instantly on revisit.
const TTL_MS = 60_000;
const store = new Map();    // path -> { data, exp }
const inflight = new Map(); // path -> Promise

async function fetchAllPages(path, params = {}) {
  // Exhaust cursor pages so reference data is always complete (no silent truncation).
  const out = [];
  let cursor = "";
  do {
    const { data } = await api.get(path, { params: { ...params, limit: 1000, ...(cursor ? { cursor } : {}) } });
    if (Array.isArray(data)) return data; // legacy non-paged endpoint
    out.push(...(data.items || []));
    cursor = data.next_cursor || "";
  } while (cursor);
  return out;
}
export { fetchAllPages };

async function cached(path) {
  const c = store.get(path);
  if (c && c.exp > Date.now()) return c.data;
  if (inflight.has(path)) return inflight.get(path);
  const p = fetchAllPages(path)
    .then((data) => {
      store.set(path, { data, exp: Date.now() + TTL_MS });
      inflight.delete(path);
      return data;
    })
    .catch((e) => { inflight.delete(path); throw e; });
  inflight.set(path, p);
  return p;
}

export const getProjects = () => cached("/projects");
export const getCrew = () => cached("/crew");
export const getBillingStatus = () => cached("/billing/status");
export const getProfile = () => cached("/profile");

export function invalidateRef(prefix) {
  for (const k of [...store.keys()]) if (k.startsWith(prefix)) store.delete(k);
}
